
import React, { Fragment, useEffect, useState } from 'react';
import { useContext } from 'react';
import { Bell, Maximize } from 'react-feather';
import { UL, LI, } from '../../../AbstractElements';
import CustomizerContext from '../../../_helper/Customizer';
import Bookmarks from './Bookmark';
import LanguageClass from './Language';
import LogoutClass from './Logout';
import MessageDrop from './MessageDrop';
import MoonLight from './MoonLight';
import Notifications from './Notifiations';
import { Col } from 'reactstrap';
import SubscriptionDetails from './SubscriptionDetail';
import { useDispatch, useSelector } from 'react-redux';
import EmailVerification from './EmailVer';
import { NavLink } from 'react-router-dom';
import { getNotificationCount, getNotificationCountRole } from '../../../CommonUrl';
import { getClientUrlDataToken } from '../../../Utils/restUtils';
import { setNotificationCount } from '../../../Redux/NotificationReducer';
import QrCodeModal from './QrCodeModal';

const Rightbar = () => {
    const { sidebarResponsive } = useContext(CustomizerContext);
    const authState = useSelector((state) => state.auth);
    const notificationSate = useSelector((state) => state?.notification);
    const dispatch = useDispatch()
    //full screen function
    function goFull() {
        if ((document.fullScreenElement && document.fullScreenElement !== null) ||
            (!document.mozFullScreen && !document.webkitIsFullScreen)) {
            if (document.documentElement.requestFullScreen) {
                document.documentElement.requestFullScreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullScreen) {
                document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }

    const notificationCount = async () => {
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getNotificationCount :
            getNotificationCountRole)
        dispatch(setNotificationCount(response?.data))

    };

    useEffect(() => {
        notificationCount()
    }, [])
    useEffect(() => {
        if (notificationSate.notifications.length > 0) {
            notificationCount();
        }
    }, [notificationSate.notifications]);
    return (
        <Fragment>
            <Col className="nav-right col-6 pull-right right-header p-0">
                <UL attrUL={{ className: `simple-list d-flex flex-row align-items-center nav-menus ${sidebarResponsive ? 'open' : ''}` }} >
                    {/* <LI attrLI={{ className: 'language-nav' }}>                        
                        <LanguageClass/>                        
                    </LI> */}
                    {/* <MoonLight /> */}
                    {/* <Bookmarks /> */}
                    {/* <Notifications /> */}
                    {/* <MessageDrop /> */}
                    {/* {authState.subStatus?.email_verified === 'no' &&
                        <EmailVerification />
                    } */}

                    <div className={notificationSate?.notificationCount === 0 ? "px-2" : "notification-box px-2"}>
                        <NavLink to={'/view-notifications'}>

                            <Bell />
                            <span className="badge rounded-pill badge-primary">{notificationSate?.notificationCount > 99
                                ? "99+" : notificationSate?.notificationCount !== 0 && notificationSate?.notificationCount}</span>
                        </NavLink>
                    </div>
                    <div className='d-none d-sm-block' style={{ padding: '0px 1px', borderRadius: '8px' }}>

                        {authState.userRole === 1 &&
                            <SubscriptionDetails />
                        }
                    </div>
                    
                    <QrCodeModal />

                    <LI attrLI={{ className: 'maximize' }}>
                        <a className="text-dark" href="#javascript" onClick={goFull}>
                            <Maximize />
                        </a>
                    </LI>
                    <LogoutClass />
                </UL>
            </Col>
        </Fragment >
    );
};

export default Rightbar;